import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=285f910a&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=285f910a&prod&lang=css"
import style1 from "./Promotions.vue?vue&type=style&index=1&id=285f910a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f910a",
  null
  
)

export default component.exports